module.exports = __webpack_public_path__ + "img/Yi_Xing.9bef6e5e.png";